function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPromotionBestFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.895 20.45l-4.25 4.24 5.13 1.03 1.03 5.13 5.42-5.43a12.32 12.32 0 01-7.32-4.96l-.01-.01zM26.095 20.45c-1.75 2.5-4.36 4.27-7.33 4.96l5.43 5.43 1.03-5.13 5.13-1.03-4.25-4.24-.01.01zM24.525 19.11a10.256 10.256 0 00-1.27-12.95c-1.92-1.92-4.54-3-7.26-3-2.03 0-4.01.6-5.7 1.73-1.69 1.13-3 2.73-3.78 4.6-.78 1.87-.98 3.93-.58 5.92.4 1.99 1.37 3.82 2.81 5.25a10.249 10.249 0 0011.17 2.23c1.87-.78 3.47-2.09 4.6-3.78h.01zm-7.39-1.14h-1.93v-7.25l-1.68 1.32-.66-1.62 2.62-1.94h1.65v9.49z",
    fill: props.color
  }));
}

export default SvgIconPromotionBestFilled;